import React, { lazy, Suspense, useEffect } from 'react';
import { Modal, CloseButton } from '@landing/ui';
import { observer, modal as modalStore } from 'store';
import { appendScriptSrc } from 'utils/scripts';
import { recaptchSrc } from 'define/scripts';
import { useIsSsr } from 'utils/hooks';

import * as styles from './RequestConsultation.module.scss';

function RequestConsultation({ animation = 'show', modalID = 'request-consultation' }) {
  const isSsr = useIsSsr();
  const isOpen = modalStore.modalID === modalID;
  const { initialEvent, getAdditionalFormData } = modalStore.modalProps;

  useEffect(() => {
    const scriptLoaded = document.getElementById('recaptcha');

    if (isOpen && !scriptLoaded) {
      appendScriptSrc(recaptchSrc, 'body', 'recaptcha');
    }
  }, [isOpen]);

  if (isOpen) {
    const ContactForm = lazy(() => import('components/ContactForm'));

    return (
      <Modal
        isOpen={isOpen}
        closeModalCallback={modalStore.close}
        closeButton={false}
        theme="fullWidthMobile"
        containerMod="wide"
        contentMod="noPadding"
        animation={animation}
      >
        {onClose => (
          <div className={styles.formWrap}>
            <CloseButton onClose={onClose} theme="light" />
            {!isSsr && (
              <Suspense fallback={null}>
                <ContactForm
                  closeModal={onClose}
                  inModal={true}
                  initialEvent={initialEvent}
                  getAdditionalFormData={getAdditionalFormData}
                />
              </Suspense>
            )}
          </div>
        )}
      </Modal>
    );
  }
  return null;
}

export default observer(RequestConsultation);
